import { createReducer } from 'store/helpers';
import filter from 'lodash/filter';
import map from 'lodash/map';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  SET_WEBHOOKS,
  DELETE_WEBHOOK,
  CREATE_WEBHOOK,
} from 'store/actions/webhooks';
import { addIdPrefix } from 'services/common';

const initialState = {
  webhooks: [],
  isFetching: false,
  error: '',
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setWebhooks = (state, { webhooks }) => state.merge({ webhooks });

const createWebhook = (state, { webhook }) => {
  const webhooks = [].concat(webhook, state.webhooks);
  return state.merge({ webhooks });
};

const deleteWebhook = (state, { webhookId }) => {
  const webhooks = filter(
    state.webhooks,
    webhook => webhook.id !== Number(webhookId),
  );
  return state.merge({ webhooks });
};

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_WEBHOOKS]: setWebhooks,
  [DELETE_WEBHOOK]: deleteWebhook,
  [CREATE_WEBHOOK]: createWebhook,
};

export default createReducer(initialState, handlers);
